import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';

const propTypes = {
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    password: PropTypes.string,
    passwordConfirmation: PropTypes.string,
  }).isRequired,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  submitLabel: PropTypes.string,
};

const PasswordSetupStep = ({
  loading,
  handleSubmit,
  handleChange,
  values,
  helperText,
  submitLabel = 'Accept invitation',
}) => {
  return (
    <form onSubmit={handleSubmit}>
      {!!helperText && (
        <p className="text-center text-muted mb-4">{helperText}</p>
      )}

      <div className="form-group mb-3">
        <label htmlFor="password" className="form-label">
          Password
        </label>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="new-password"
          className="form-control"
          value={values.password}
          onChange={handleChange}
          minLength={8}
          required
        />
      </div>

      <div className="form-group mb-4">
        <label htmlFor="passwordConfirmation" className="form-label">
          Confirm password
        </label>
        <input
          id="passwordConfirmation"
          name="passwordConfirmation"
          type="password"
          autoComplete="new-password"
          className="form-control"
          value={values.passwordConfirmation}
          onChange={handleChange}
          minLength={8}
          required
        />
      </div>

      <Button
        type="submit"
        disabled={loading}
        loading={loading}
        className="btn-primary w-100 mb-3"
        btnSize="lg"
      >
        {submitLabel}
      </Button>

      <p className="text-muted small text-center mb-0">
        By continuing you agree to <a href="/terms">Terms of Use</a> &{' '}
        <a href="/privacy">Privacy Policy</a>
      </p>
    </form>
  );
};

PasswordSetupStep.propTypes = propTypes;

export default PasswordSetupStep;
